// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8tMcL","title":"styles_title__8iGaU","regularTitle":"styles_regularTitle__cPTit","subTitle":"styles_subTitle__uqT0S","form":"styles_form__b1RhW"};